import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../Icons.jsx';
import { copyText } from '../../lib/freePreview.js';
import { trackPreview } from '../../lib/freePreviewEvents.js';

export default function CopyTextButton({ text, index = null, className = 'btn btn-secondary btn-sm' }) {
  const { t } = useTranslation();
  const [state, setState] = useState('idle');
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const onClick = async () => {
    const ok = await copyText(text || '');
    setState(ok ? 'copied' : 'failed');
    if (ok) trackPreview('preview_draft_copied', { index });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setState('idle'), 2500);
  };
  return <>
    <button type="button" className={`${className} fp-copy`} onClick={onClick} aria-live="polite">
      <Icon name={state === 'copied' ? 'check' : 'copy'} size={13} /> {state === 'copied' ? t('freePreview.copied') : t('freePreview.copyText')}
    </button>
    {state === 'failed' && <span className="fp-copy-failed" role="status">{t('freePreview.copyFailed')}</span>}
  </>;
}
